var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8516 5.60156H18.414V17.3932H11.8516V5.60156Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2709 11.5C12.2709 9.1042 13.3958 6.97916 15.1249 5.60413C13.8542 4.60415 12.2501 4 10.5001 4C6.35412 4 3 7.35412 3 11.5C3 15.6458 6.35412 19 10.5 19C12.25 19 13.8541 18.3959 15.1249 17.3958C13.3958 16.0416 12.2709 13.8958 12.2709 11.5Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2695 11.5C27.2695 15.6458 23.9154 19 19.7695 19C18.0195 19 16.4154 18.3959 15.1445 17.3958C16.8945 16.0208 17.9987 13.8958 17.9987 11.5C17.9987 9.1042 16.8736 6.97916 15.1445 5.60413C16.4153 4.60415 18.0195 4 19.7695 4C23.9154 4 27.2695 7.375 27.2695 11.5Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.2ec5bd657b15d0fefef71413d19faba4.svg";
export { ForwardRef as ReactComponent };